import React from 'react';
import { Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import LanguageContext from '../../helper/LanguageContext';
import { CompanyFeed } from "./CompanyFeed";
import { callAPI } from "../../helper/apiUtils";
import { UserFeed } from "./UserFeed";
import { Link, withRouter } from "react-router-dom";
import { Scrollbars } from 'react-custom-scrollbars';
import { ARTICLE } from "../../store";
import { connect } from "react-redux";
import FeedViewDialog from "./Dialogs/FeedViewDialog";
import { $user } from "../../helper/UserFactory";
import { $crud } from "../../helper/CrudFactory";
import { canManageCompanyArticle } from "../../helper/articleAdminRights";
import "./FeedDetail.css";

const user = $user.get();

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        {...props}
    />
);


class FeedDetail extends React.Component {

    static contextType = LanguageContext;

    constructor(props) {
        super(props);
        this.state = {
            hasMore: 'true',
            articles: [],
            companies: [],
            showDeleteConfirm: false,
            articleToDelete: null,
        }
    }


    handleLike = async (id) => {
        const articleDetails = this.state.articles.find(article => article.id === id);
        if (!articleDetails) return;
        const articlesList = this.state.articles.map(article => {
            if (article.id !== articleDetails.id) return article;
            const likes = Array.isArray(article.likes) ? [...article.likes] : [];
            const existUser = likes.find(like => like.id === user?.id);
            let newLikes, newCount, newLikeStatus;
            if (existUser) {
                // User already liked -> remove like
                newLikes = likes.filter(like => like.id !== user?.id);
                newCount = Math.max(0, (articleDetails.likeCount || 0) - 1);
                newLikeStatus = false;
            } else {
                // User hasn't liked -> add like
                newLikes = [{ 
                    id: user?.id, 
                    avatar: user?.avatar,
                    userFullName: user?.fullName || user?.name
                }, ...likes];
                newCount = (articleDetails.likeCount || 0) + 1;
                newLikeStatus = true;
            }
            return { ...article, likeStatus: newLikeStatus, likes: newLikes, likeCount: newCount };
        });
        this.setState({ articles: articlesList });
    }


    getProfile = async () => {
        const { data } = await callAPI(`/company/my`, {}, "GET");
        if (data.status) {
            this.setState({ companies: data.companies || [] });
        }
    };

    getArticleCompanyId = (article = {}) => {
        if (article.createdBy === "company" && article.createdById) {
            return article.createdById;
        }
        if (article.companyId) {
            return article.companyId;
        }
        if (article.company) {
            return typeof article.company === "object" ? article.company.id : article.company;
        }
        return null;
    };

    getFeedArticleManageProps = (article, isInternal) => {
        if (!article || article.createdBy === "user") {
            return { canManageArticle: false };
        }
        const companyId = this.getArticleCompanyId(article);
        const company = (this.state.companies || []).find((item) => item.id === companyId);
        const canManage = canManageCompanyArticle(article, company || {}, { isInternal });
        return {
            canManageArticle: canManage,
            onEditArticle: canManage
                ? () => {
                    if (!article?.id || !companyId) {
                        return;
                    }
                    this.props.history.push({
                        pathname: `/edit-company-article/${companyId}/${article.id}`,
                        state: {
                            from: isInternal ? "internal" : "external",
                            articleType: isInternal ? 1 : 0,
                            companyId,
                            fromFeeds: true,
                        },
                    });
                }
                : undefined,
            onDeleteArticle: canManage
                ? () => this.setState({ showDeleteConfirm: true, articleToDelete: article })
                : undefined,
        };
    };

    confirmDeleteFeedArticle = async () => {
        const article = this.state.articleToDelete;
        this.setState({ showDeleteConfirm: false });
        if (!article?.id) {
            this.setState({ articleToDelete: null });
            return;
        }
        try {
            const { data } = await callAPI(`/article/${article.id}`, {}, "DELETE");
            $crud.notify({
                type: data.status ? "success" : "error",
                message: data.message,
            });
            if (data.status) {
                this.props.history.push("/articles");
            }
        } catch (error) {
            console.error("Failed to delete article", error);
            $crud.notify({
                type: "error",
                message: this.context.isGerm ? "Aktion fehlgeschlagen." : "Failed to delete article.",
            });
        } finally {
            this.setState({ articleToDelete: null });
        }
    };

    get = async () => {
        const id = this.props.match.params.id;

        const { data: { article } } = await callAPI('/article/' + id, {}, 'GET')

        const updatedArticles = article.map((article) => {
            article.expand = false;
            return article;
        })
        console.log(article)
        await this.setState({ articles: updatedArticles })
    }

    componentDidMount() {
        this.getProfile();
        this.get()
    }

    expandArticle = key => {
        this.setState(state => {
            const articles = state.articles
            let article = articles[key];
            article.expand = true
            articles[key] = article;
            return { articles: articles }
        })
    }
    handleFollow = async (id, followStatus) => {
        const articleDetails = await this.state.articles.find(article => article.id === id)
        console.log(followStatus)
        const articlesList = this.state.articles.map(article => {
            if (article.postedById === articleDetails.postedById) {
                article.followStatus = followStatus ? false : true;
            }
            return article;
        })
        this.setState({ articles: articlesList })

    }


    render() {
        return (
            <React.Fragment>
                <Layout>
                    <div className="w-300 add_company pt-0 feed-detail">
                        {/* <div className="main_heading">
                            <Link to="/articles">
                                <span 
                                    className="material-symbols-outlined"
                                    style={{
                                        fontFamily: 'Material Symbols Outlined',
                                        fontSize: '24px',
                                        width: '24px',
                                        height: '24px',
                                        color: '#737373',
                                        display: 'inline-block',
                                        verticalAlign: 'middle',
                                        fontVariationSettings: '"FILL" 0, "wght" 300, "GRAD" 0, "opsz" 24',
                                        fontStyle: 'normal',
                                        fontWeight: 300,
                                        lineHeight: 1
                                    }}
                                >
                                    keyboard_arrow_left
                                </span>
                            </Link>
                            {this.context.strings.feed_details}
                        </div> */}
                        <div className={`${(this.props.location.state && this.props.location.state.isInternal) ? "main_heading main_heading-internal" : "main_heading"} feed-detail__heading`}>
                            <a className="pointer">
                                <Link to="/articles">
                                    {!(this.props.location.state && this.props.location.state.isInternal) ?
                                        <span 
                                            className="material-symbols-outlined feed-detail__back-icon"
                                        >
                                            keyboard_arrow_left
                                        </span>
                                        :
                                        <span 
                                            className="material-symbols-outlined custom-svg feed-detail__back-icon"
                                        >
                                            keyboard_arrow_left
                                        </span>
                                    }
                                </Link>
                            </a>
                            <Link to="/articles">

                            <div className={`feed-detail__title${(this.props.location.state && this.props.location.state.isInternal) ? ' feed-detail__title--internal' : ''}`}>
                                    {this.context.strings.feed_details}
                            </div>
                            </Link>

                            <div />
                        </div>
                        <div className="wscroll feed-detail__scroll">
                                {
                                    this.state.articles &&
                                    this.state.articles.map((article, key) => (
                                        <div key={key} className="media-desc p-2">
                                            {
                                                (article.createdBy === 'user') ?
                                                    <UserFeed handleFollow={this.handleFollow}
                                                        handleLike={this.handleLike}
                                                        reloadArticle={() => this.get()} index={key}
                                                        article={article}
                                                        isDetails={true}
                                                        viewArticleDetail={(article) => this.props.viewArticle(article, this.state.articles, key)}
                                                        expandArticle={this.expandArticle} />
                                                    :
                                                    <CompanyFeed handleLike={this.handleLike}
                                                        handleFollow={this.handleFollow}
                                                        reloadArticle={() => this.get()} index={key}
                                                        article={article}
                                                        isDetails={true}
                                                        isInternal={(this.props.location.state && this.props.location.state.isInternal) ? true : false}
                                                        viewArticleDetail={(article) => this.props.viewArticle(article, this.state.articles, key)}
                                                        expandArticle={this.expandArticle}
                                                        {...this.getFeedArticleManageProps(
                                                            article,
                                                            !!(this.props.location.state && this.props.location.state.isInternal)
                                                        )} />

                                            }
                                        </div>
                                    ))
                                }
                        </div>
                    </div>
                    {
                        this.props.article &&
                        <FeedViewDialog 
                            article={this.props.article} 
                            articlesList={this.props.articlesList || []}
                            currentArticleIndex={this.props.currentArticleIndex || 0}
                        />
                    }
                    <Modal
                        show={this.state.showDeleteConfirm}
                        onHide={() => this.setState({ showDeleteConfirm: false, articleToDelete: null })}
                        animation={false}
                        centered
                    >
                        <Modal.Body>
                            <p>{this.context.strings.delete_article_confirm}</p>
                        </Modal.Body>
                        <Modal.Footer className="feed-detail__modal-footer">
                            <button type="button" className="kj-btn kj-btn--outline" onClick={() => this.setState({ showDeleteConfirm: false, articleToDelete: null })}>
                                {this.context.strings.cancel}
                            </button>
                            <button type="button" className="kj-btn kj-btn--outline" onClick={this.confirmDeleteFeedArticle}>
                                {this.context.strings.ok}
                            </button>
                        </Modal.Footer>
                    </Modal>
                </Layout>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    const { article, articlesList, currentArticleIndex } = state;
    console.log(article);
    return {
        article: article,
        articlesList: articlesList || [],
        currentArticleIndex: currentArticleIndex || 0,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        viewArticle: (article, articlesList, currentIndex) => dispatch({ 
            type: ARTICLE, 
            article: article,
            articlesList: articlesList || [],
            currentArticleIndex: currentIndex !== undefined ? currentIndex : 0
        })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FeedDetail));
